import React, { useState } from 'react';
import { snakeCase } from 'lodash';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import CtaButtonContainer from '../../../../components/elements/CtaButton/CtaButtonContainer';
import { sendAnalyticsEvent } from '../../../../services/analytics';
import { QUESTION_ID } from '../Quiz/constants';
import Question from '../Quiz/Question';
import { HeroLeft, HeroRight, HeroTitle, HeroWrapper, Image } from './components';
import CtaButton from '../../../../components/elements/CtaButton';
import { useIsMobile } from '../../../../hooks/screenSizeHooks';
const variantsStyles = require('./HeroQuiz.module.css');

function QuizQuestion({ onSelectOption, selectedOption }) {
  return (
    <>
      <CodeSparkThemedTypography variant="h4">ALL KIDS CAN CODE</CodeSparkThemedTypography>
      <CodeSparkThemedTypography
        variant="subtitle2"
        className={variantsStyles.quizQuestionSubtitle}
      >
        We’ll show you how codeSpark uses your child’s unique learning style to teach coding
      </CodeSparkThemedTypography>

      <div className={variantsStyles.quizQuestionOptions}>
        <Question onSelectOption={onSelectOption} selectedOption={selectedOption} />
      </div>
    </>
  );
}

function HeroQuiz({ onCtaClick, data }) {
  const { title, heroImageMobile, heroImageDesktop, ctaLabel } = data;
  const [selectedOption, setSelectedOption] = useState();
  const heroImage = useIsMobile() ? heroImageMobile : heroImageDesktop;

  const handleClick = e => {
    sendAnalyticsEvent('web_onboarding_quiz_question_answered', {
      app: 'web-site',
      question_name: snakeCase(QUESTION_ID),
      screen_name: 'homepage',
    });

    onCtaClick(e, {
      questionId: QUESTION_ID,
      answer: selectedOption,
    });
  };

  return (
    <HeroWrapper className={variantsStyles.heroVariant1}>
      <HeroLeft className={`small-order-2 large-order-1 ${variantsStyles.heroLeft}`}>
        <HeroTitle>{title}</HeroTitle>

        <Image src={heroImage} className={variantsStyles.heroVariant1Image} />
      </HeroLeft>

      <HeroRight className="small-order-1 large-order-2">
        <div className={variantsStyles.heroRightSpacing}>
          <QuizQuestion selectedOption={selectedOption} onSelectOption={setSelectedOption} />

          <CtaButtonContainer>
            <CtaButton
              type="primary"
              data-event-action="homepage-hero"
              data-event-label={ctaLabel}
              onClick={handleClick}
              fullWidthMobile
            >
              {ctaLabel}
            </CtaButton>
          </CtaButtonContainer>
        </div>
      </HeroRight>
    </HeroWrapper>
  );
}

export default HeroQuiz;



// WEBPACK FOOTER //
// ./src/containers/Home/sections/Hero/HeroQuiz.js